import { Spiner } from "@components/loaders/spiner";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Form, Input, message } from "antd";
import { NoticeType } from "antd/es/message/interface";
import { useEffect, useState } from "react";

import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";

export const BiographPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";
  const gender = dataNis?.data?.gender ?? "";

  const { data, isPending, refetch } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  const { mutate: onUpdateBio, isPending: isPendingUpdateBio } = useMutation({
    mutationFn: SchoolService.updateStudentBiography,
    onSuccess: (response) => {
      setShowMessage(true);
      setMessageType("success");
      setShowMessageText(response.message);

      refetch();
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  useEffect(() => {
    // refetch();
    window.scrollTo(0, 0);
    setAppBar({ title: "Biodata", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Biodata",
      image: false,
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <Form
          className=""
          autoComplete="off"
          initialValues={{
            nis: data?.data?.nis,
            namasiswa: data?.data?.namasiswa,
            kotaLahir: data?.data?.kotalahir,
            tanggalLahir: data?.data?.tanggallahir,
            namaAyah: data?.data?.namaayah,
            namaIbu: data?.data?.namaibu,
            pekerjaanAyah: data?.data?.pekerjaanayah,
            pekerjaanIbu: data?.data?.pekerjaanibu,
            // telephon: data?.data?.telephon,
            alamat: data?.data?.alamat,
            kelas: data?.data?.kelas,
            nama: data?.data?.nama,
          }}
          onFinish={(data) => onUpdateBio(data)}
        >
          <div className="tw-mb-4 tw-mt-12 tw-pt-14 tw-relative tw-text-center card-body">
            <div className="tw-p-2 tw-rounded-full tw-text-center tw-mb-4 tw-absolute tw-top-0 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2">
              <img
                src={
                  isPending
                    ? MaleLogo
                    : data?.data?.foto === null || data?.data?.foto === ""
                    ? gender === "Pria" || gender === "PRIA" || gender === ""
                      ? MaleLogo
                      : FemaleLogo
                    : `https://sip2.darululumkalbar.com//assets/fotosiswa/${data?.data?.foto}`
                }
                alt=""
                className="tw-w-24 tw-h-24 tw-object-cover tw-rounded-full tw-aling-middle tw-border-[5px] tw-border-solid tw-border-primary tw-bg-gray-100"
              />
            </div>

            <div className="tw-text-lg tw-font-medium tw-text-text-primary">
              {data?.data?.namasiswa ?? "---"}
            </div>

            <div className="tw-text-xs tw-text-text-secondary">
              Kelas {data?.data?.kelas}
            </div>

            <div className="tw-text-xs tw-text-text-secondary">
              Marhalah {data?.data?.marhalah}
            </div>

            <div className="tw-my-4 divider"></div>
            {isPending ? (
              <div className="tw-p-8 tw-text-center">
                <Spiner />
              </div>
            ) : (
              <div className="student-bio">
                <Form.Item label="NIS" name="nis" className="tw-mb-4">
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="NIS"
                    disabled={true}
                    // value={watch("nis")}
                  />
                </Form.Item>

                <Form.Item label="Nama" name="namasiswa" className="tw-mb-4">
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Nama"
                  />
                </Form.Item>

                <Form.Item
                  label="Tempat Lahir"
                  name="kotaLahir"
                  className="tw-mb-4"
                >
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Kota Lahir"
                  />
                </Form.Item>

                <Form.Item
                  label="Tanggal Lahir"
                  name="tanggalLahir"
                  className="tw-mb-4"
                >
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    type="date"
                  />
                </Form.Item>
              </div>
            )}
          </div>

          {isPending ? (
            <div className="tw-p-8 tw-text-center card-body">
              <Spiner />
            </div>
          ) : (
            <>
              <div className="tw-mb-4 card-body">
                <Form.Item
                  label="Nama Ayah"
                  name="namaAyah"
                  className="tw-mb-4"
                >
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Nama Ayah"
                  />
                </Form.Item>

                <Form.Item label="Nama Ibu" name="namaIbu" className="tw-mb-4">
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Nama Ibu"
                  />
                </Form.Item>

                <Form.Item
                  label="Pekerjaan Ayah"
                  name="pekerjaanAyah"
                  className="tw-mb-4"
                >
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Pekerjaan Ayah"
                  />
                </Form.Item>

                <Form.Item
                  label="Pekerjaan Ibu"
                  name="pekerjaanIbu"
                  className="tw-mb-4"
                >
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Pekerjaan Ibu"
                  />
                </Form.Item>

                <Form.Item label="Alamat" name="alamat" className="tw-mb-4">
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Alamat"
                  />
                </Form.Item>
              </div>

              <div className="tw-mb-4 card-body">
                <Form.Item label="Kelas" name="kelas" className="tw-mb-4">
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Kelas"
                    disabled={true}
                  />
                </Form.Item>

                <Form.Item label="Wali Kelas" name="nama" className="tw-mb-4">
                  <Input
                    className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="Wali Kelas"
                    disabled={true}
                  />
                </Form.Item>
              </div>
              <Button
                type="primary"
                htmlType="submit"
                loading={isPendingUpdateBio}
                className="tw-p-2 tw-mt-4 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-warm-orange tw-text-neutral-background focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-primary hover:tw-border-primary"
              >
                {isPendingUpdateBio ? "" : "Update"}
              </Button>
            </>
          )}
        </Form>
      </div>
    </>
  );
};
